<!--
 * @Description: 常规工作/日常事务 工资表
 * @Author: 王赵坤
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2025-06-06 17:17:03
 * @FilePath: \VUE3\src\components\home\gongzibiao.vue
-->
<template>
  <div>
    <el-dialog class="wp90 hp90" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">工资表</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-select placeholder="工资类型" v-model="dataGrid.parms.gzlx" clearable filterable @change="bindTable()">
                  <el-option label="正常" :value="0" />
                  <el-option label="补发" :value="1" />
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker placeholder="工资年月" v-model="dataGrid.parms.gzny" type="month" format="YYYY-MM" value-format="YYYY-MM" @change="bindTable()" />
              </el-form-item>
              <el-form-item>
                <el-input placeholder="工号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                  <template #suffix>
                    <el-icon class="el-input__icon pointer" @click="bindTable()">
                      <search />
                    </el-icon>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true">补发工资</el-button>
              <el-button type="primary" @click="opengenerate=true">生成工资表</el-button>
              <el-button type="primary" @click="copyAdd=true">复制工资表</el-button>
              <el-button type="primary" @click="submitData()">提交</el-button>
              <el-dropdown>
                <el-button class="w200" type="info">
                  <el-icon class="el-icon--left">
                    <DocumentCopy />
                  </el-icon>导入/导出<el-icon class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </el-button>
                <template #dropdown>
                  <el-dropdown-menu class="w200">
                    <el-dropdown-item>
                      <el-upload :http-request="importInsert" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel导入数据</el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <el-upload :http-request="importCover" :auto-upload="true" :show-file-list="false" accept=".xlsx, .xls">Excel覆盖数据</el-upload>
                    </el-dropdown-item>
                    <el-dropdown-item @click="exportData" divided>导出到Excel</el-dropdown-item>
                    <el-dropdown-item @click="download">下载Excel模板</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" show-summary :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="工号" prop="gh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="教职工" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />

              <el-table-column label="开户名" prop="khxm" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input v-if="tableind===scope.$index" v-model="scope.row.khxm" :min="0" controls-position="right" clearable />
                  <span v-else>{{scope.row.khxm}}</span>
                </template>
              </el-table-column>
              <el-table-column label="开户银行" prop="khyh" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input v-if="tableind===scope.$index" v-model="scope.row.khyh" :min="0" controls-position="right" clearable />
                  <span v-else>{{scope.row.khyh}}</span>
                </template>
              </el-table-column>
              <el-table-column label="银行卡号" prop="yhkh" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input v-if="tableind===scope.$index" v-model="scope.row.yhkh" :min="0" controls-position="right" clearable />
                  <span v-else>{{scope.row.yhkh}}</span>
                </template>
              </el-table-column>
              <el-table-column label="工资类型" prop="gzlx" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-tag v-if="scope.row.gzlx === 0" type="success">正常</el-tag>
                  <el-tag v-if="scope.row.gzlx === 1" type="info">补发</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="工资年月" prop="gzny" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span>{{scope.row.gzny}}</span>
                </template>
              </el-table-column>
              <el-table-column label="实发金额" header-align="center" prop="sfje" align="center" sortable show-overflow-tooltip :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <el-input-number v-if="tableind===scope.$index" v-model="scope.row.sfje" :min="0" controls-position="right" />
                  <span v-else>{{scope.row.sfje}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="item.gzxmc" v-for="(item,index) in gongzixiang" :key="item.id" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <el-input-number v-if="tableind===scope.$index" v-model="scope.row.gzbgzxs[index].je" :min="0" controls-position="right" />
                  <span v-else>{{scope.row.gzbgzxs[index].je}}</span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="150" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="warning" v-if="scope.row.gzlx === 1&&scope.row.cwzt===0" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                  <el-button link type="success" @click="tableind=null;isedit=null;qvxiao(scope.row)" v-if="(isedit==0||isedit==1)&&tableind==scope.$index">取消</el-button>
                  <el-button link type="success" @click="tableind=scope.$index;isedit=0;getgzjz(scope.row);" v-if="scope.row.id==null&&tableind!=scope.$index">录入</el-button>
                  <el-button link type="primary" @click="tableind=scope.$index;isedit=1;xiugai(scope.row)" v-if="scope.row.id!=null&&tableind!=scope.$index">修改</el-button>
                  <el-button link type="primary" v-if="(isedit==0||isedit==1)&&tableind==scope.$index" @click="primary(scope.row)">保存</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
    <!-- 办理 弹窗 结束 -->
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <copy v-if="copyAdd" v-model:copyAdd="copyAdd" @ReturnData="bindTable" />
  <generate v-if="opengenerate" v-model:opengenerate="opengenerate" @ReturnData="bindTable" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import {
  loadList,
  submitDataGridAction,
  submitExcel,
  exportExcel,
  downloadTemplate,
  loadSelect,
  actionPost,
  submitForm,
  submitEditForm,
  homeCloseWindow
} from '@/api/common.js'
import { ElMessageBox } from 'element-plus'
import add from './add.vue'
import copy from './copy.vue'
import generate from './generate.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const tableind = ref(null)
const ruleFormRef = ref(null)
const beifen = ref()
const gzjzdata = ref() // 工资基准
const isedit = ref(null)
const gongzixiang = ref([])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'gh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.data = []
  gongzixiang.value = []
  loadList({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.data = res.data.pagelist.list
      loadSelect({
        url: '/api/v2/caiwu/caiwugongzixiang/list',
        data: gongzixiang,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          dataGrid.value.data.forEach((item, index) => {
            item.gzny = dataGrid.value.parms.gzny
            gongzixiang.value = res.data
            if (item.id === null) {
              gongzixiang.value.forEach((element) => {
                element.je = 0
              })
              item.gzbgzxs = JSON.parse(JSON.stringify(gongzixiang.value))
            } else {
              const gongzixiangid = item.jzggzxs.map((gzx) => {
                return gzx.gzxid
              })
              gongzixiang.value.forEach((element) => {
                item.jzggzxs.forEach((gzxid) => {
                  if (
                    element.id === gzxid.gzxid &&
                    gzxid.jzgid === item.jzgid
                  ) {
                    element.je = gzxid.je
                  } else if (
                    gongzixiangid.indexOf(element.id) === -1 &&
                    gzxid.jzgid === item.jzgid
                  ) {
                    element.je = 0
                  }
                })
              })
              item.gzbgzxs = JSON.parse(JSON.stringify(gongzixiang.value))
            }
          })
          beifen.value = JSON.parse(JSON.stringify(dataGrid.value.data))
        }
      })
    }
  })
}

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}
// 修改
const xiugai = (val) => {
  dataGrid.value.data.forEach((item) => {
    beifen.value.forEach((element) => {
      if (item.id === null) {
        item.khxm = ''
        item.khyh = ''
        item.sfje = 0
        item.yhkh = ''
        gongzixiang.value.forEach((element) => {
          element.je = 0
        })
        item.gzbgzxs = JSON.parse(JSON.stringify(gongzixiang.value))
      } else if (item.id === element.id && item.jzgid === element.jzgid) {
        item.khxm = element.khxm
        item.khyh = element.khyh
        item.sfje = element.sfje
        item.yhkh = element.yhkh
        item.gzbgzxs = JSON.parse(JSON.stringify(element.gzbgzxs))
      }
    })
  })
}
// 取消
const qvxiao = (val) => {
  
  if (val.id !== null) {
    loadSelect({
      url: '/api/v2/caiwu/jiaozhigonggongzibiao/' + val.id,
      order: 'gh',
      data: gzjzdata,
      sort: 'asc',
      loadSuccess: function (res) {
        val.khxm = res.data.khxm
        val.khyh = res.data.khyh
        val.sfje = res.data.sfje
        val.yhkh = res.data.yhkh
        val.gzbgzxs.forEach((item) => {
          res.data.jzggzxs.forEach((element) => {
            if (item.id === element.gzxid) {
              item.je = element.je
            }
          })
        })
      }
    })
  } else {
    
    val.khxm = ''
    val.khyh = ''
    val.sfje = 0
    val.yhkh = ''
    val.gzbgzxs.forEach((item) => {
      item.je = 0
    })
  }
}
// 获取工资基准 录入
const getgzjz = (val) => {
  
  loadSelect({
    url: '/api/v2/caiwu/caiwugongzijizhun/list/' + val.jzgid,
    order: 'gh',
    data: gzjzdata,
    sort: 'asc',
    loadSuccess: function (res) {
      val.khxm = res.data.khxm
      val.khyh = res.data.khyh
      val.sfje = res.data.sfje
      val.yhkh = res.data.yhkh
      val.gzbgzxs.forEach((item) => {
        res.data.gzjzxs.forEach((element) => {
          if (item.id === element.gzxid) {
            item.je = element.je
          }
        })
      })
    }
  })
  dataGrid.value.data.forEach((item) => {
    beifen.value.forEach((element) => {
      if (item.id === null && item.jzgid !== val.jzgid) {
        item.khxm = ''
        item.khyh = ''
        item.sfje = 0
        item.yhkh = ''
        gongzixiang.value.forEach((element) => {
          element.je = 0
        })
        item.gzbgzxs = JSON.parse(JSON.stringify(gongzixiang.value))
      } else if (item.id === element.id && item.jzgid === element.jzgid) {
        item.khxm = element.khxm
        item.khyh = element.khyh
        item.sfje = element.sfje
        item.yhkh = element.yhkh
        item.gzbgzxs = JSON.parse(JSON.stringify(element.gzbgzxs))
      }
    })
  })
}
// 提交
const submitData = () => {
  const data = {
    gzny: dataGrid.value.parms.gzny
  }
  ElMessageBox.confirm('您确定要提交吗', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    actionPost({
      url: '/api/v2/caiwu/jiaozhigonggongzibiao/tijiaoshenpi',
      data: data
    }).then((res) => {
      bindTable()
    })
  })
}

// 修改 录入
const primary = async (val) => {
  if (isedit.value === 0) {
    const form = unref(ruleFormRef)
    if (!form) return
    await form.validate()
    const data = {
      jzgid: val.jzgid,
      khxm: val.khxm,
      khyh: val.khyh,
      yhkh: val.yhkh,
      sfje: val.sfje,
      gzlx: 0,
      gzny: val.gzny,
      menuId: sessionStorage.getItem('menuId'),
      gzbgzxs: []
    }
    val.gzbgzxs.forEach((item, index) => {
      const obj = {
        gzxid: item.id,
        je: Number(item.je) || 0
      }
      data.gzbgzxs.push(obj)
    })
    submitForm({
      url: '/api/v2/caiwu/jiaozhigonggongzibiao',
      ruleFormRef: unref(ruleFormRef),
      ruleForm: data,
      callback: function (res) {
        isedit.value = null
        tableind.value = null
        bindTable()
      }
    })
  } else if (isedit.value === 1) {
    const form = unref(ruleFormRef)
    if (!form) return
    await form.validate()
    const data = {
      cwgzbid: val.cwgzbid,
      id: val.id,
      jzgid: val.jzgid,
      khxm: val.khxm,
      khyh: val.khyh,
      yhkh: val.yhkh,
      sfje: val.sfje,
      gzlx: val.gzlx,
      gzny: val.gzny,
      jianXJE: val.jianXJE,
      jiaXJE: val.jiaXJE,
      zt: val.zt,
      menuId: sessionStorage.getItem('menuId'),
      gzbgzxs: []
    }
    data.gzbgzxs = []
    val.gzbgzxs.forEach((item, index) => {
      const obj = {
        gzxid: item.id,
        je: Number(item.je) || 0
      }
      data.gzbgzxs.push(obj)
    })

    submitEditForm({
      url: '/api/v2/caiwu/jiaozhigonggongzibiao',
      ruleFormRef: unref(ruleFormRef),
      ruleForm: data,
      callback: function (res) {
        bindTable()
        isedit.value = null
        tableind.value = null
      }
    })
  }
}
// // 获取当前年月上一个一个月
const huoqvdangqiannianyve = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth()
  dataGrid.value.parms.gzny = `${year}-0${month}`
  bindTable()
}

// 弹窗
const openAdd = ref(false)
const copyAdd = ref(false)
const opengenerate = ref(false)
const openList = ref(false)

// Excel导入数据
const importInsert = async (file) => {
  submitExcel({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/importInsert',
    file: file,
    callback: function (res) {
      bindTable()
    }
  })
}
// Excel覆盖数据
const importCover = async (file) => {
  submitExcel({
    url: '/api/v2/caiwu/jiaozhigonggongzibiao/importCover',
    file: file,
    callback: function (res) {
      bindTable()
    }
  })
}

// Excel导出
const exportData = async () => {
  exportExcel('/api/v2/caiwu/jiaozhigonggongzibiao/export', dataGrid.value)
}

// 模板下载
const download = async () => {
  downloadTemplate('/api/v2/caiwu/jiaozhigonggongzibiao/download')
}

watch(
  () => props.open,
  () => {
    if (props.open === 'gongzibiao') {
      openList.value = true
      huoqvdangqiannianyve()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
